<template>
    <div>
        <div class="footer-class">

                <!--<div style="float: left; width: 33%; text-align: left;">
                    <div>
                        &nbsp;
                    </div>
                </div>-->
                <div>
                        <p>copyrights &copy; {{new Date().getFullYear()}} Don Quijote Recepciones | all rights reserved</p>
                </div>
                <!-- --><div style="float: left; width: 33%; text-align: right;">
                    
                    <!--<a :href="'https://api.whatsapp.com/send?phone=5491125300899'">
                                   <img 
                                    style="cursor: pointer; position: absolute; bottom: 15px; right: 10px;" 
                                    width="50" src="https://donquijote.b-cdn.net/necesitoefectivo/whatsapp.png" alt="" srcset="">
                                </a>   --> 
                </div><!-- -->
            </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Footer/Index.vue